import ol from "openlayers";
import Config from "src/config.json";
import "moment-timezone";

// 緯度チェック
function isLatInValid(val) {
  return 90 > val && val > -90 && val !== 0;
}
// 経度チェック
function isLonInValid(val) {
  return 180 > val && val > -180 && val !== 0;
}

//  TripのデータをMap用のデータに変換
function convertTripData(eventData, selectPeriodFrom, selectPeriodTo) {
  var coordinates = [];

  // 経路を作成
  if(eventData){
    eventData.forEach(function(point, index) {
      if (isLatInValid(point.lat) && isLonInValid(point.lon) && selectPeriodFrom <= point.tm && point.tm <= selectPeriodTo ) {
        coordinates.push({
          lat: point.lat,
          lon: point.lon
        });
      }
    });
  }

  // ルート情報とマーカー情報を返却
  return coordinates;
}

// データ取得完了時のレスポンスを受け取った時の処理
function showEventGPSPoints(showSafetyMapPoints, selectPeriodFrom, selectPeriodTo, heatMapLayer) {
  // 取得したTripのデータを地図用データに変換
  var coordinates = convertTripData(showSafetyMapPoints, selectPeriodFrom, selectPeriodTo);

  // 座標情報をヒートマップ用に変換
  var heatPoints = coordinates.map(
    point =>
      new ol.Feature(
        new ol.geom.Point(ol.proj.fromLonLat([point.lon, point.lat]))
      )
  );

  heatMapLayer.getSource().addFeatures(heatPoints);
  heatMapLayer.setGradient(["#00c", "#0ff", "#ff0", "#f00"]);
  heatMapLayer.setVisible(true);
}

// Mapを作成する
function createMap(target, layers) {
  return new ol.Map({
    target: target,
    controls: ol.control.defaults({}).extend([new ol.control.ScaleLine()]),
    layers: layers,
    view: new ol.View({
      center: ol.proj.fromLonLat([
        Config.MAP["DEFAULT_LON"],
        Config.MAP["DEFAULT_LAT"]
      ]),
      zoom: 10,
      minZoom: 8,
      maxZoom: 17
    })
  });
}

// Mapに表示するレイヤー等を作成する
function EventMapDrawing(mapId, safetyMapData, accidentDataList, logCarId, selectPeriodFrom, selectPeriodTo, radius, blur) {
  this.mapId = mapId;
  // 地図用のレイヤー作成
  this.mapLayer = new ol.layer.Tile({
    source: new ol.source.OSM()
  });

  // ヒートマップ用のレイヤー
  this.heatMapLayer = new ol.layer.Heatmap({
    source: new ol.source.Vector(),
    zIndex: 1
  });

  this.heatMapLayer.setRadius(radius);
  this.heatMapLayer.setBlur(blur);

  // マーカー用のレイヤー
  this.markerLayer = new ol.layer.Vector({
    source: new ol.source.Vector(),
    zIndex: 2
  });

  // レイヤー配列
  let layers = [];
  layers.push(this.mapLayer);
  layers.push(this.markerLayer);
  layers.push(this.heatMapLayer);

  // 地図を作成
  this.map = createMap(this.mapId, layers);

  // Tripデータ取得
  // レスポンスをresponse関数の引数とする
  showEventGPSPoints(safetyMapData["listLonLat"], selectPeriodFrom, selectPeriodTo, this.heatMapLayer);
}

export default EventMapDrawing;



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventMapDrawing.js